<template>
    <section class="title2">
        <ogt-video ref="video" src="/static/video/onderwijskwaliteit.mp4" poster="/static/video/onderwijskwaliteit-poster.jpg"></ogt-video>
        <p>Hier werkten we aan in 2020 - onze 5 strategische doelen</p>
        <div class="list">
            <div class="point active">
                <div class="number">1</div>
                <label>Aantoonbare <br/>onderwijs&shy;kwaliteit</label>
            </div>
            <div class="point" @click="$router.push('/Carriere')">
                <div class="number">2</div>
                <label>Opleiden voor <br/>een carri&egrave;re</label>
            </div>
            <div class="point" @click="$router.push('/Regio')">
                <div class="number">3</div>
                <label>Positie in <br class="hide-for-small" />de regio</label>
            </div>
            <div class="point" @click="$router.push('/Medewerker')">
                <div class="number">4</div>
                <label>Medewerker<br />3.0</label>
            </div>
            <div class="point" @click="$router.push('/Duurzaam')">
                <div class="number">5</div>
                <label>Duurzaam <br/>verbeteren</label>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .list *{
        transition: all 0.4s ease-out;
    }
</style>

<script>
    import VideoEmbed from '@/app/pages/onderwijskwaliteit/VideoEmbed';
    import Tekst from '@/app/pages/onderwijskwaliteit/Tekst';
    import InterviewTitle from '@/app/pages/onderwijskwaliteit/InterviewTitle';
    import Quote from '@/app/pages/onderwijskwaliteit/Quote';
    // import InfoStudieSuccess from '@/app/pages/onderwijskwaliteit/InfoStudieSuccess.vue';
    import OgtVideo from '@/app/components/OgtVideo';

    import InterviewKirsten from '@/app/pages/sub/InterviewKirsten';

    export default {
        name: 'Onderwijskwaliteit',
        meta: {
            title: '4.1 Aantoonbare onderwijskwaliteit',
            color: '#fe1362',
            sub: true,
            slides: [ Tekst, VideoEmbed, InterviewTitle, Quote ]
        },

        components: {
            'ogt-video': OgtVideo
        },

        props: {
            meta: {
                default: () => {},
                type: Object
            }
        },

        mounted()
        {
        },

        methods: {
            focus()
            {
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            },
            sub( name )
            {
                switch( name )
                {
                    case 'Kirsten':
                        this.$emit( 'openOverlay', InterviewKirsten, this.meta.index + 3 );
                        break;
                }
            }
        }
    };
</script>
